export default window.React;
